import superagent from 'superagent';
import Debug from 'debug';
const debug = Debug('gh:lobuilder:shortanswer');
$(() => {
// enter key pressed
    $('.learnerName').keypress((e) => {
        if (e.which == 13) {
            $('.learnerSubmit').click();
            if (event) {
                event.returnValue = false;
            }
            event.preventDefault ? event.preventDefault() : event.returnValue = false;
        }
    });

        // store the learner's name in cookie
    $('body').on('click', '.learnerSubmit', (e) => {
        const inputVal = $('.learnerName').val();
        $('.modal').modal('hide');
        $('.learnervariable').hide();
        Cookies.set('learnername', inputVal, {
            expires: 7,
            path: '/',
        });
        Cookies.set('autoModal', '1', {
            expires: 7,
            path: '/',
        });
    });

        //  call page controller function through ajax
    $('body').on('click', '.js__short_answer__feedback-button--peer-feedback', (e) => {
        const activityEl = $(e.target).parents('.js__short-answer')[0];
        const responseEl = $(activityEl).find('.gh__block__short_answer__input')[0];
        const value = $(responseEl).val();
            // if (value == '') $(this).trigger('focus');

        const activityid = $(activityEl).attr('data-block-id');
            // Cookies.set('MemberShortAnswer', value, {
            //     expires: 7,
            //     path: '/',
            // });
            // Cookies.set('PeerActivityID', activityid, {
            //     expires: 7,
            //     path: '/',
            // });
        debug('Saving the short answer response', value, 'for activity', activityid);
        superagent
                .post('/gh-api/peerfeedback/response')
                .send({
                    response_text: value,
                    activity_id: activityid,
                })
                .end((err, res, body) => {
                    if (err) console.error(err);
                    else if (res.body.destroyed == false) {
                        console.log('Saved the short answer response for peer review');
                    } else {
                        console.error('Problem saving short answer response', res.text);
                    }
                });
    });

        // send peer feedback
    $('body').on('click', '.sendPeerFeedback', (e) => {
        const activityEl = $(e.target).parents('.js__short-answer')[0];
        const previousResponseEl = $(activityEl).find('.js__short-answer--peer-feedback__previous-response')[0];

        let feedback = $($(activityEl).find('.PeerFeedbackContent')[0]).val();
        const activity_id = $(activityEl).attr('data-block-id');
        const learner_response_id = $(previousResponseEl).attr('data-learner-response-id');
        if (feedback == '') {
            feedback = 'Empty Response';
        }
            // const activityid = $(activityEl).attr('data-block-id');
        let moderateEmail;
            // if ($('.shortanswermoderate').length > 0) {
            //     url = '/gh-api/peerfeedback/moderate';
            //     moderateEmail = $('.shortanswermoderate').text();
            //     datastring = `Feedback=${feedback}&Moderate=${moderateEmail}`;
            // }
        debug('Saving the short answer peer feedback', feedback, 'for activity', activity_id, 'learner reponse', learner_response_id);

        superagent
                .post('/gh-api/peerfeedback/addfeedback')
                .send({
                    feedback_from_peer: feedback,
                    activity_id,
                    learner_response_id,
                })
                .end((err, res, body) => {
                    if (err) console.error(err);
                    else if (res.text == 'The feedback has been sent') {
                        console.log('Saved the feedback for the short answer response');
                    } else {
                        console.error('Problem saving the feedback for the short answer response', res.text);
                    }
                });
        $(activityEl).find('.PeerAnswer').hide();
        $(activityEl).find('.shortAnswerPeerAlert').show();
    });

        // go to next tab
    $('body').on('click', '.goToNextTab', function () {
        if (event) {
            event.returnValue = false;
        }
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
        const tabID = `#${$(this).attr('href').match(/#([^ ]*)/)[1]}`;
        $(`li > a[href$=${tabID}]`).trigger('click');
    });

        // add multiple features to plan
    const multiplefeatures = $('.multiFeature');
    $('body').on('click', '.multiFeature', function () {
        if ($(this).hasClass('Selected')) {
            $(this).removeClass('Selected');
        } else {
            $(this).addClass('Selected');
        }
    });

        // save multiple features as learning goals into database

    $('.addFeatureToPlan').unbind('click');
    $('body').on('click', '.addFeatureToPlan', function () {
        const target = $(this);
        const selected = target.parent();

        const url = '/SaveAsController/SaveToDatabase';
            // var context = $(this).parent().attr('id').replace('MultiChoiceQuestion', '');
        const context = '';
        const verb = 'Add Learning Goals';
        let datastring = `activityid=${context}&Verb=${verb}`;
        let object = '';
            // console.log(selected);
        const temp = selected.eq(0);
        console.log(temp);

        const name = temp.find('label').text();

        const desc = $(temp).next('.featureDescription').html();

        object = `${name}-:-${desc}`;

        datastring += `&Object=${object}`;

        $.ajax({
            type: 'POST',
            url,
            data: datastring,
        });

            // var dataString = JSON.stringify(window.SelectedPlan);
            // var saveAs = '/SaveAsController//SaveAs?content=' + dataString;
            // var newWindow = window.open(saveAs, '');
            // $(this).text('You have successfully add learning goals to Your Plan');
        $(this).attr('disabled', true);
    });

        // delete learner statement from Glasshouse
    $('body').on('click', '.removeStatement', function () {
        const statementid = $(this).attr('data-statementid');
        const url = '/SaveAsController/DeletePlan';
        const datastring = `id=${statementid}`;
        $.ajax({
            type: 'POST',
            url,
            data: datastring,
        });
            // console.log($(this).parent().parent().parent().remove());

        $(this).closest('.PlanChoice').remove();
        $(this).closest('.accordion-group').remove();


            // $(this).closest('.panel').remove();
    });

        // add comment
    $('body').on('click', '.SendComment', function () {
        const ActivityID = $(this).attr('data-commentid');
        const object = $(`#CommentContent${ActivityID}`).val();
        if ($.trim(object).length > 0) { // only add non-empty comment
            const verb = 'Add Comment';
            let isAnonymous = '0';
            if ($(`#Anonymous${ActivityID}`).is(':checked')) {
                isAnonymous = '1';
            }
            let show = '0';
            if ($(this).parent().parent().hasClass('showAnonymous')) { // show Anonymous comment
                show = '1';
            }
            let url = '/CollaborationController/AddComment'; // save comment to Glasshouse database
                // data for Tin Can statement
            const activityName = $(this).attr('data-activity-name');
            const mBox = window.glasshouseEmail;
            const userName = window.glasshouseUserName;
            const pageTitle = $('.page-title').text();
            const idPrefix = `${window.location}#Comment${ActivityID}-`;
            let dataString = `ActivityID=${ActivityID}&Object=${object}&Verb=${verb}&Anonymous=${isAnonymous}&showAnonymous=${show}`;

            $.ajax({
                type: 'POST',
                url,
                data: dataString,
                dataType: 'json',
                Comment: object, // pass variables
                mBox,
                userName,
                activityName,
                pageTitle,
                idPrefix,
                success(data) {
                        // console.log(data[0]);
                        // alert('.LoadComments'+data[2]);

                    $(`.LoadComments${data[2]}`).html(data[0]);
                    const ActivityName = `${this.pageTitle} - ${this.activityName} - Comment Activity`;
                        // recordTinCanStatement(this.idPrefix + data[1], ActivityName, 'add Comment', this.Comment);
                        // console.log(object);
                        // console.log(mBox);
                        // console.log(userName);
                        // console.log(pageTitle);
                },
            });


            $(`#CommentContent${ActivityID}`).val('');
                // send action email to moderator
            const allowModerate = $(this).attr('data-moderate');
            if (allowModerate == '1') {
                const email = $(this).attr('data-email');
                const action = 'add';
                dataString = `ActivityID=${ActivityID}&Email=${email}&Action=${action}&Object=${object}`;
                url = '/CollaborationController/sendCommentToModerator';
                $.ajax({
                    type: 'POST',
                    url,
                    data: dataString,
                });
            }
        } else {
            $(this).siblings('.message').text('Your comment cannot be empty. ');
        }
            // console.log(dataString);
            // $(this).text('Comment Sent');
            // $(this).attr('disabled',true);
    });
        // delete comment
    $('body').on('click', '.deleteComment', function () {
        const commentid = $(this).attr('data-CommentID');
        const ActivityID = $(this).attr('data-ActivityID');
        const allowModerate = $(this).attr('data-moderate');
        const email = $(this).attr('data-email');

            // delete comment from database
        let show = '0';
        if ($(`#Comment${ActivityID}`).hasClass('showAnonymous')) {
            show = '1';
        }
        const url = '/CollaborationController/DeleteComment';
        const dataString = `id=${commentid}&ActivityID=${ActivityID}&showAnonymous=${show}`;

        $.ajax({
            type: 'POST',
            url,
            data: dataString,
            dataType: 'json',
            success(dataDelete) {
                    // / alert('about to delete');
                    // alert(data[1]);
                    // console.log(data);
                $(`.LoadComments${dataDelete[1]}`).html(dataDelete[0]);
            },
        });


        $(`CommentItem${commentid}`).html('');
    });

    $('.js__short-answer__response.js__block__short_answer__emptyfeedback').blur(function (e){
        var response = $(this).val();
        var activitynum = $(this).attr('data-shortanswer-id')
        if(response && activitynum) {
            window.store.dispatch(window.actions.shortQuestionAnswerFeedback(activitynum, response));    
        }
    })
        // save activities
        // $('.SaveActivities button').on('click', function(){
        //     var selected = $('.isActivity:has(.saveactivities:checked)');
        //     var url = '/SaveAsController/SaveToDatabase';
        //     var context = $(this).parent().parent().attr('div');
        //     var verb = 'Add Activities';
        //     var object = "";
        //     var datastring = 'activityid='+context+'&Verb='+verb;
        //     if (selected.length > 0) {
        //         for(var i=0; i<selected.length; i++) {
        //             var temp = selected.eq(i);
        //             var name = temp.find('.Question').text();
        //             if(temp.hasClass('ShortAnswerQuestion')){
        //                 var desc = temp.find('.Response').find('textarea').val();
        //             }
        //             object += '<Question: '+name+', Answer: '+desc+'>.';
        //             // window.SelectedActivity[name] = desc;
        //         }
        //         datastring += '&Object='+object;
        //         $.ajax({
        //             type:"POST",
        //             url:url,
        //             data:datastring,
        //         });
        //         // var dataString = JSON.stringify(window.SelectedActivity);
        //         // console.log(window.SelectedActivity);
        //         // var saveAs = '/SaveAsController//SaveAs?content=' + dataString;
        //         // var newWindow = window.open(saveAs, '');
        //     }
        // });

        // save Note into database
        // $('button.saveNote').on('click', function(){
        //     var activity = $(this).closest('.ChildActivities').siblings('.isActivity');
        //     var activityid = '';
        //     if(activity.hasClass('ShortAnswerQuestion')) {
        //         activityid = activity.attr('id').split('ShortAnswerQuestion')[1];
        //     }
        //     var noteContent = $(this).siblings('.Response').find('textarea').val();
        //     var url = '/SaveAsController/SaveToDatabase';
        //     var action = 'Add Note';
        //     var datastring = 'activityid='+ activityid + '&Object='+noteContent+'&Verb='+action;
        //     $.ajax({
        //         type: "POST",
        //         url: url,
        //         data:datastring,
        //     });
        //     $(this).hide();
        //     var feedbackmsg = $(this).siblings('.Feedback');
        //     feedbackmsg.show();
        //     feedbackmsg.text('Your Note has been successfully saved to database');
        // });
});



// WEBPACK FOOTER //
// Glasshouse/Core/js/shortanswer.js